/**
 * HASAD Premium Theme — theme.js
 * Vanilla JS, no framework dependencies.
 * window.HASAD holds global config injected by theme.liquid
 */

(function () {
  'use strict';

  /* -------------------------------------------------------------------------
     Global Config (populated by theme.liquid via window.HASAD)
  ------------------------------------------------------------------------- */
  window.HASAD = window.HASAD || {
    routes: {
      cart_add_url: '/cart/add.js',
      cart_change_url: '/cart/change.js',
      cart_url: '/cart.js',
      search_url: '/search/suggest',
      root_url: '/',
    },
    strings: {
      addToCart: 'Sepete Ekle',
      added: 'Sepete Eklendi',
      soldOut: 'Tükendi',
      unavailable: 'Mevcut Değil',
      cartEmpty: 'Sepetiniz boş',
      freeShipping: 'Ücretsiz kargo!',
      freeShippingProgress: '{{amount}} daha ekleyin, ücretsiz kargo kazanın!',
      close: 'Kapat',
    },
    moneyFormat: '{{amount}} TL',
    freeShippingThreshold: 500,
  };

  /* -------------------------------------------------------------------------
     Utility: formatMoney
  ------------------------------------------------------------------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var priceParts;
    format = format || window.HASAD.moneyFormat;

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(num, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, '.');
      decimal = defaultOption(decimal, ',');

      if (isNaN(num) || num === null) return 0;

      num = (num / 100.0).toFixed(precision);
      priceParts = num.split('.');
      priceParts[0] = priceParts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return priceParts.join(decimal);
    }

    switch (format.match(/\{\{\s*(\w+)\s*\}\}/)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* -------------------------------------------------------------------------
     Utility: debounce
  ------------------------------------------------------------------------- */
  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn.apply.bind(fn, this, arguments), delay);
    };
  }

  /* -------------------------------------------------------------------------
     Toast Notifications
  ------------------------------------------------------------------------- */
  var Toast = {
    container: null,

    init: function () {
      this.container = document.getElementById('toast-container');
      if (!this.container) {
        this.container = document.createElement('div');
        this.container.id = 'toast-container';
        this.container.className = 'toast-container';
        this.container.setAttribute('aria-live', 'polite');
        document.body.appendChild(this.container);
      }
    },

    show: function (message, type, duration) {
      type = type || 'success';
      duration = duration || 3500;

      var toast = document.createElement('div');
      toast.className = 'toast toast--' + type;
      toast.setAttribute('role', 'status');
      toast.textContent = message;

      this.container.appendChild(toast);

      setTimeout(function () {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, duration + 400);
    },
  };

  /* -------------------------------------------------------------------------
     CartDrawer
  ------------------------------------------------------------------------- */
  var CartDrawer = {
    drawer: null,
    overlay: null,
    body: null,
    subtotalEl: null,
    countEl: null,
    progressBar: null,
    progressText: null,

    init: function () {
      this.drawer = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('cart-drawer-overlay');
      if (!this.drawer) return;

      this.body = this.drawer.querySelector('[data-cart-items]');
      this.subtotalEl = this.drawer.querySelector('[data-cart-subtotal]');
      this.countEl = document.querySelectorAll('[data-cart-count]');
      this.progressBar = this.drawer.querySelector('[data-shipping-progress]');
      this.progressText = this.drawer.querySelector('[data-shipping-text]');

      // Close triggers
      var self = this;
      if (this.overlay) {
        this.overlay.addEventListener('click', function () { self.close(); });
      }

      var closeBtn = this.drawer.querySelector('[data-cart-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () { self.close(); });
      }

      // Open triggers
      document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });

      // Keyboard close
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.drawer.classList.contains('is-open')) {
          self.close();
        }
      });
    },

    open: function () {
      this.fetch();
      this.drawer.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.drawer.setAttribute('aria-hidden', 'false');
    },

    close: function () {
      this.drawer.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      this.drawer.setAttribute('aria-hidden', 'true');
    },

    fetch: function () {
      var self = this;
      fetch(window.HASAD.routes.cart_url, {
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () { /* silent fail */ });
    },

    render: function (cart) {
      this.updateCount(cart.item_count);
      this.updateSubtotal(cart.total_price);
      this.updateProgress(cart.total_price);
      if (this.body) this.renderItems(cart);
    },

    renderItems: function (cart) {
      if (cart.item_count === 0) {
        this.body.innerHTML =
          '<div class="cart-drawer__empty">' +
          '<div class="cart-drawer__empty-icon">' +
          '<svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><path d="M3 6h18M16 10a4 4 0 01-8 0"/></svg>' +
          '</div>' +
          '<p>' + window.HASAD.strings.cartEmpty + '</p>' +
          '</div>';
        return;
      }

      var html = '';
      cart.items.forEach(function (item) {
        html +=
          '<div class="cart-item" data-cart-item="' + item.key + '">' +
          '<img class="cart-item__image" src="' + (item.image ? item.image.replace('.jpg', '_144x144.jpg') : '') + '" alt="' + item.title + '" width="72" height="72" loading="lazy">' +
          '<div class="cart-item__info">' +
          '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' +
          (item.variant_title ? '<span class="cart-item__variant">' + item.variant_title + '</span>' : '') +
          '<div class="cart-item__bottom">' +
          '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
          '<div class="cart-item__qty">' +
          '<button class="cart-item__qty-btn" data-qty-change="-1" data-key="' + item.key + '" aria-label="Azalt">−</button>' +
          '<span class="cart-item__qty-value">' + item.quantity + '</span>' +
          '<button class="cart-item__qty-btn" data-qty-change="1" data-key="' + item.key + '" aria-label="Artır">+</button>' +
          '</div>' +
          '<button class="cart-item__remove" data-remove-item="' + item.key + '" aria-label="Kaldır">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6M9 6V4h6v2"/></svg>' +
          '</button>' +
          '</div>' +
          '</div>' +
          '</div>';
      });

      this.body.innerHTML = html;
      this.bindItemEvents();
    },

    bindItemEvents: function () {
      var self = this;

      this.body.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-key');
          var change = parseInt(btn.getAttribute('data-qty-change'));
          var item = btn.closest('[data-cart-item]');
          var qtyEl = item.querySelector('.cart-item__qty-value');
          var currentQty = parseInt(qtyEl.textContent);
          var newQty = Math.max(0, currentQty + change);
          self.changeItem(key, newQty);
        });
      });

      this.body.querySelectorAll('[data-remove-item]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-remove-item');
          self.changeItem(key, 0);
        });
      });
    },

    changeItem: function (key, quantity) {
      var self = this;
      fetch(window.HASAD.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () {});
    },

    updateCount: function (count) {
      this.countEl.forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    },

    updateSubtotal: function (price) {
      if (this.subtotalEl) {
        this.subtotalEl.textContent = formatMoney(price);
      }
    },

    updateProgress: function (total) {
      if (!this.progressBar || !this.progressText) return;
      var threshold = (window.HASAD.freeShippingThreshold || 500) * 100;
      var pct = Math.min((total / threshold) * 100, 100);
      this.progressBar.style.width = pct + '%';

      if (total >= threshold) {
        this.progressText.innerHTML = '<strong>' + window.HASAD.strings.freeShipping + '</strong>';
      } else {
        var remaining = formatMoney(threshold - total);
        this.progressText.innerHTML = window.HASAD.strings.freeShippingProgress.replace('{{amount}}', remaining);
      }
    },

    addItem: function (variantId, quantity, properties, successCb) {
      var self = this;
      quantity = quantity || 1;
      properties = properties || {};

      fetch(window.HASAD.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function (item) {
          Toast.show(item.product_title + ' ' + window.HASAD.strings.added, 'success');
          self.fetch();
          self.open();
          if (successCb) successCb(item);
        })
        .catch(function () {
          Toast.show('Ürün eklenemedi, lütfen tekrar deneyin.', 'error');
        });
    },
  };

  /* -------------------------------------------------------------------------
     Quick Add (product card buttons)
  ------------------------------------------------------------------------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.setAttribute('disabled', 'disabled');
      var originalHTML = btn.innerHTML;
      btn.innerHTML = '<span class="spinner spinner--sm spinner--white"></span>';

      CartDrawer.addItem(variantId, 1, {}, function () {
        btn.removeAttribute('disabled');
        btn.innerHTML = originalHTML;
      });
    });

    // Variant selection in quick add
    document.addEventListener('click', function (e) {
      var varBtn = e.target.closest('[data-variant-id][data-quick-variants] .product-card__variant-btn, .product-card__variant-btn[data-variant-id]');
      if (!varBtn) return;
      var parent = varBtn.closest('[data-quick-add]') || varBtn.closest('.product-card__variants');
      if (!parent) return;

      parent.querySelectorAll('.product-card__variant-btn').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      varBtn.classList.add('is-selected');

      var addBtn = varBtn.closest('[data-quick-add]').querySelector('[data-add-to-cart]');
      if (addBtn) addBtn.setAttribute('data-variant-id', varBtn.getAttribute('data-variant-id'));
    });
  }

  /* -------------------------------------------------------------------------
     Predictive Search
  ------------------------------------------------------------------------- */
  var PredictiveSearch = {
    input: null,
    results: null,
    currentQuery: '',

    init: function () {
      this.input = document.querySelector('[data-predictive-search-input]');
      this.results = document.querySelector('[data-predictive-search-results]');
      if (!this.input || !this.results) return;

      var self = this;
      this.input.addEventListener(
        'input',
        debounce(function () {
          var q = self.input.value.trim();
          if (q.length < 2) {
            self.close();
            return;
          }
          if (q === self.currentQuery) return;
          self.currentQuery = q;
          self.fetch(q);
        }, 300)
      );

      this.input.addEventListener('focus', function () {
        if (self.input.value.trim().length >= 2) self.show();
      });

      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-predictive-search]')) self.close();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });
    },

    fetch: function (query) {
      var self = this;
      var url =
        window.HASAD.routes.search_url +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&section_id=predictive-search';

      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var inner = doc.getElementById('shopify-section-predictive-search');
          self.results.innerHTML = inner ? inner.innerHTML : '';
          self.show();
        })
        .catch(function () {});
    },

    show: function () {
      this.results.setAttribute('aria-hidden', 'false');
      this.results.style.display = 'block';
    },

    close: function () {
      this.results.setAttribute('aria-hidden', 'true');
      this.results.style.display = 'none';
      this.currentQuery = '';
    },
  };

  /* -------------------------------------------------------------------------
     Sticky Header
  ------------------------------------------------------------------------- */
  var StickyHeader = {
    header: null,
    lastScrollY: 0,
    scrollThreshold: 80,

    init: function () {
      this.header = document.getElementById('site-header');
      if (!this.header || !this.header.dataset.sticky) return;

      var self = this;
      window.addEventListener(
        'scroll',
        debounce(function () { self.onScroll(); }, 10),
        { passive: true }
      );
    },

    onScroll: function () {
      var y = window.scrollY;

      if (y > this.scrollThreshold) {
        this.header.classList.add('header--compact');
      } else {
        this.header.classList.remove('header--compact');
      }

      if (y > this.lastScrollY && y > 200) {
        this.header.classList.add('header--hidden');
      } else {
        this.header.classList.remove('header--hidden');
      }

      this.lastScrollY = y;
    },
  };

  /* -------------------------------------------------------------------------
     VariantPicker
  ------------------------------------------------------------------------- */
  var VariantPicker = {
    init: function () {
      document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
        picker.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-option-btn]');
          if (!btn) return;

          var optionWrapper = btn.closest('[data-option-group]');
          if (optionWrapper) {
            optionWrapper.querySelectorAll('[data-option-btn]').forEach(function (b) {
              b.classList.remove('is-selected');
              b.setAttribute('aria-pressed', 'false');
            });
          }
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');

          VariantPicker.updateVariant(picker);
        });
      });
    },

    updateVariant: function (picker) {
      var selectedOptions = [];
      picker.querySelectorAll('[data-option-group]').forEach(function (group) {
        var selected = group.querySelector('[data-option-btn].is-selected');
        if (selected) selectedOptions.push(selected.dataset.optionValue);
      });

      var variantsData = picker.dataset.variants;
      if (!variantsData) return;

      var variants = JSON.parse(variantsData);
      var matched = variants.find(function (v) {
        return selectedOptions.every(function (opt, i) {
          return v.options[i] === opt;
        });
      });

      if (!matched) return;

      // Update price
      var priceEl = document.querySelector('[data-product-price]');
      var comparePriceEl = document.querySelector('[data-product-compare-price]');
      if (priceEl) priceEl.textContent = formatMoney(matched.price);
      if (comparePriceEl) {
        if (matched.compare_at_price > matched.price) {
          comparePriceEl.textContent = formatMoney(matched.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // Update add to cart button
      var addBtn = document.querySelector('[data-product-add-btn]');
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', matched.id);
        if (!matched.available) {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = window.HASAD.strings.soldOut;
        } else {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = window.HASAD.strings.addToCart;
        }
      }

      // Update URL
      var url = new URL(window.location.href);
      url.searchParams.set('variant', matched.id);
      window.history.replaceState({}, '', url.toString());

      // Update featured image if available
      if (matched.featured_image) {
        var mainImg = document.querySelector('[data-product-main-image]');
        if (mainImg) {
          mainImg.src = matched.featured_image.src.replace('.jpg', '_800x.jpg');
          mainImg.alt = matched.featured_image.alt || '';
        }
      }
    },
  };

  /* -------------------------------------------------------------------------
     QuantitySelector
  ------------------------------------------------------------------------- */
  function initQuantitySelectors() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quantity-btn]');
      if (!btn) return;

      var wrapper = btn.closest('[data-quantity-wrapper]');
      if (!wrapper) return;

      var input = wrapper.querySelector('[data-quantity-input]');
      if (!input) return;

      var val = parseInt(input.value) || 1;
      var dir = btn.dataset.quantityBtn;
      var min = parseInt(input.min) || 1;
      var max = parseInt(input.max) || 999;

      if (dir === 'increase') val = Math.min(val + 1, max);
      if (dir === 'decrease') val = Math.max(val - 1, min);

      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* -------------------------------------------------------------------------
     Accordion
  ------------------------------------------------------------------------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (acc) {
      var header = acc.querySelector('[data-accordion-header]');
      if (!header) return;

      header.addEventListener('click', function () {
        var isOpen = acc.classList.contains('is-open');

        // Close siblings if in a group
        var group = acc.closest('[data-accordion-group]');
        if (group) {
          group.querySelectorAll('[data-accordion].is-open').forEach(function (sibling) {
            sibling.classList.remove('is-open');
            var sibHeader = sibling.querySelector('[data-accordion-header]');
            if (sibHeader) sibHeader.setAttribute('aria-expanded', 'false');
          });
        }

        acc.classList.toggle('is-open', !isOpen);
        header.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  /* -------------------------------------------------------------------------
     Tabs
  ------------------------------------------------------------------------- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (tabGroup) {
      var tabs = tabGroup.querySelectorAll('[data-tab]');
      var panels = tabGroup.querySelectorAll('[data-tab-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.tab;

          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t.dataset.tab === target);
            t.setAttribute('aria-selected', String(t.dataset.tab === target));
          });

          panels.forEach(function (panel) {
            panel.classList.toggle('is-active', panel.dataset.tabPanel === target);
          });
        });
      });
    });
  }

  /* -------------------------------------------------------------------------
     ScrollReveal
  ------------------------------------------------------------------------- */
  var ScrollReveal = {
    observer: null,

    init: function () {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('[data-reveal]').forEach(function (el) {
          el.classList.add('is-visible');
        });
        return;
      }

      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              ScrollReveal.observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );

      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        ScrollReveal.observer.observe(el);
      });
    },
  };

  /* -------------------------------------------------------------------------
     Mobile Menu
  ------------------------------------------------------------------------- */
  var MobileMenu = {
    menu: null,
    overlay: null,

    init: function () {
      this.menu = document.getElementById('mobile-menu');
      this.overlay = document.getElementById('mobile-menu-overlay');
      if (!this.menu) return;

      var self = this;

      document.querySelectorAll('[data-mobile-menu-open]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.open(); });
      });

      var closeBtn = this.menu.querySelector('[data-mobile-menu-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });

      if (this.overlay) {
        this.overlay.addEventListener('click', function () { self.close(); });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.menu.classList.contains('is-open')) {
          self.close();
        }
      });

      // Submenu toggles
      this.menu.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.dataset.submenuToggle;
          var submenu = document.getElementById(target);
          if (submenu) submenu.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', String(submenu.classList.contains('is-open')));
        });
      });
    },

    open: function () {
      this.menu.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.menu.setAttribute('aria-hidden', 'false');
    },

    close: function () {
      this.menu.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      this.menu.setAttribute('aria-hidden', 'true');
    },
  };

  /* -------------------------------------------------------------------------
     Heroic slideshow (auto-play + dots)
  ------------------------------------------------------------------------- */
  function initSlideshows() {
    document.querySelectorAll('[data-slideshow]').forEach(function (slider) {
      var slides = slider.querySelectorAll('[data-slide]');
      var dots = slider.querySelectorAll('[data-slide-dot]');
      var current = 0;
      var speed = parseInt(slider.dataset.slideshowSpeed) || 5000;
      var total = slides.length;
      var timer;

      if (total < 2) return;

      function goTo(idx) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (idx + total) % total;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function next() { goTo(current + 1); }

      function startAuto() { timer = setInterval(next, speed); }
      function stopAuto() { clearInterval(timer); }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          stopAuto();
          goTo(i);
          startAuto();
        });
      });

      var prevBtn = slider.querySelector('[data-slide-prev]');
      var nextBtn = slider.querySelector('[data-slide-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { stopAuto(); goTo(current - 1); startAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { stopAuto(); goTo(current + 1); startAuto(); });

      startAuto();
    });
  }

  /* -------------------------------------------------------------------------
     Featured Products Tabs + Carousel (sections/featured-products)
  ------------------------------------------------------------------------- */
  function initFeaturedProducts() {
    document.querySelectorAll('[data-featured-products]').forEach(function (widget) {
      var tabs = widget.querySelectorAll('[data-fp-tab]');
      var panels = widget.querySelectorAll('[data-fp-panel]');
      var prevBtn = widget.querySelector('[data-fp-prev]');
      var nextBtn = widget.querySelector('[data-fp-next]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.fpTab;
          tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.fpTab === target); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.fpPanel === target); });
        });
      });

      function scrollPanel(dir) {
        var activePanel = widget.querySelector('[data-fp-panel].is-active .fp-track');
        if (!activePanel) return;
        var card = activePanel.querySelector('.product-card');
        var cardW = card ? card.offsetWidth + 20 : 260;
        activePanel.scrollBy({ left: dir * cardW * 2, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollPanel(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollPanel(1); });
    });
  }

  /* -------------------------------------------------------------------------
     Announcement Bar — rotation
  ------------------------------------------------------------------------- */
  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    // Dismiss
    var closeBtn = bar.querySelector('[data-announcement-close]');
    if (closeBtn) {
      if (sessionStorage.getItem('hasad-announcement-dismissed')) {
        bar.style.display = 'none';
        return;
      }
      closeBtn.addEventListener('click', function () {
        bar.style.display = 'none';
        sessionStorage.setItem('hasad-announcement-dismissed', '1');
      });
    }

    // Rotation
    var messages = bar.querySelectorAll('[data-announcement-msg]');
    if (messages.length < 2) return;

    var speed = parseInt(bar.dataset.textSpeed) || 4000;
    var idx = 0;

    setInterval(function () {
      messages[idx].classList.remove('is-active');
      idx = (idx + 1) % messages.length;
      messages[idx].classList.add('is-active');
    }, speed);
  }

  /* -------------------------------------------------------------------------
     Story Section — basic parallax
  ------------------------------------------------------------------------- */
  function initParallax() {
    var parallaxEls = document.querySelectorAll('[data-parallax]');
    if (!parallaxEls.length) return;

    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      parallaxEls.forEach(function (el) {
        var speed = parseFloat(el.dataset.parallax) || 0.3;
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var offset = (center - window.innerHeight / 2) * speed;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
    }, { passive: true });
  }

  /* -------------------------------------------------------------------------
     Wishlist (localStorage)
  ------------------------------------------------------------------------- */
  function initWishlist() {
    function getWishlist() {
      try { return JSON.parse(localStorage.getItem('hasad-wishlist') || '[]'); }
      catch (_) { return []; }
    }

    function saveWishlist(list) {
      localStorage.setItem('hasad-wishlist', JSON.stringify(list));
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();

      var id = btn.dataset.wishlistToggle;
      var list = getWishlist();
      var idx = list.indexOf(id);

      if (idx === -1) {
        list.push(id);
        btn.classList.add('is-active');
        Toast.show('Favorilere eklendi', 'success');
      } else {
        list.splice(idx, 1);
        btn.classList.remove('is-active');
        Toast.show('Favorilerden çıkarıldı', 'info');
      }

      saveWishlist(list);
    });

    // Mark existing
    var list = getWishlist();
    list.forEach(function (id) {
      var btn = document.querySelector('[data-wishlist-toggle="' + id + '"]');
      if (btn) btn.classList.add('is-active');
    });
  }

  /* -------------------------------------------------------------------------
     DOMContentLoaded — Boot
  ------------------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    Toast.init();
    CartDrawer.init();
    StickyHeader.init();
    VariantPicker.init();
    PredictiveSearch.init();
    MobileMenu.init();
    ScrollReveal.init();
    initAccordions();
    initTabs();
    initQuantitySelectors();
    initQuickAdd();
    initSlideshows();
    initFeaturedProducts();
    initAnnouncementBar();
    initParallax();
    initWishlist();
  });

  // Expose for external access
  window.HASAD.CartDrawer = CartDrawer;
  window.HASAD.Toast = Toast;
  window.HASAD.formatMoney = formatMoney;
})();
